import type { RelativeImageOffset } from '../../types';
import type { Point } from '../objects/StrokeEvaluator';

type ImageDimensions = {
	displayWidth: number;
	displayHeight: number;
	originX: number;
	originY: number;
};

const IMAGE_GAP_RATIO = 0.1;

export function getImagePlacement(
	endpoint: Point,
	direction: Point,
	image: ImageDimensions,
	extension: -1 | 1,
	offset?: RelativeImageOffset,
): Point {
	const { displayWidth: width, displayHeight: height, originX, originY } = image;
	if (offset) {
		return { x: endpoint.x + offset[0] * width, y: endpoint.y + offset[1] * height };
	}
	const length = Math.hypot(direction.x, direction.y);
	const dx = extension * (length > 0 ? direction.x / length : 1);
	const dy = extension * (length > 0 ? direction.y / length : 0);
	// Keep the entire image beyond the endpoint's perpendicular plane, including an off-center origin.
	const nearestEdge =
		Math.min(-originX * width * dx, (1 - originX) * width * dx) +
		Math.min(-originY * height * dy, (1 - originY) * height * dy);
	const distance = Math.max(0, -nearestEdge) + Math.max(width, height) * IMAGE_GAP_RATIO;
	return { x: endpoint.x + dx * distance, y: endpoint.y + dy * distance };
}
